import React from "react";
import { getDataConfig } from "../config";
import "../styles/ProductCard.css";

const ProductCard = ({ product, onSelectProduct, onOpenLightbox }) => {
  const config = getDataConfig();
  const imageUrl = config.getImageUrl(product.codigo);
  const defaultImage = `${process.env.PUBLIC_URL}/images/placeholder.webp`;

  return (
    <div className="product-card">
      <div className="product-image" onClick={() => onOpenLightbox(product)}>
        <img
          src={imageUrl}
          alt={product.nombre}
          loading="lazy"
          onError={(e) => {
            e.target.src = defaultImage;
            e.target.onerror = null;
          }}
        />
        <div className="image-zoom-hint">🔍 Click para ampliar</div>
      </div>
      <div className="product-info">
        <h3 className="product-title">{product.nombre}</h3>
        <p className="product-code">Código: {product.codigo}</p>
        <p className="product-unit">Unidad: {product.unidad}</p>
        <div className="product-price-row">
          <span className="product-price">${product.precio.toFixed(2)}</span>
          <span className="product-price">({product.pv_usd.toFixed(2)} USD)</span>

          <span
            className={`product-stock ${product.disponible ? "in-stock" : "out-stock"}`}
          >
            {product.disponible ? `Stock: ${product.cantidad}` : "Agotado"}
          </span>
        </div>
        {product.disponible && (
          <button
            className="select-product-btn"
            onClick={(e) => {
              e.stopPropagation();
              onSelectProduct(product);
            }}
          >
            🛒 Seleccionar
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
